import {useSearchParams} from "react-router-dom";
import {Alert, Tabs} from "antd";
import {Button, FontAwesomeIcon, PageHeader} from "~/components";
import {useGetMySubscriptionQuery} from "~/reduxs/api/subscriptionApiSlice";
import ApiKeysPanel from "../components/ApiKeysPanel";
import WebhooksPanel from "../components/WebhooksPanel";
import ApiDocs from "../components/ApiDocs";

const TABS = ['keys', 'webhooks', 'docs'];

/**
 * Trang "API & Webhook" (#25 — "API hệ thống", cờ gói can_use_api):
 *  - API Keys : credential dài hạn gọi API public v1 (header X-API-Key).
 *  - Webhooks : đẩy sự kiện (crawl xong, token sắp cạn...) tới URL ngoài, ký HMAC.
 *  - Tài liệu : hướng dẫn endpoint v1 + xác minh chữ ký webhook.
 *
 * Trang xem được với mọi user (tài liệu + dọn dẹp key/webhook cũ); thao tác TẠO/SỬA
 * bị BE gate 402 theo gói — FE disable nút kèm gợi ý nâng cấp cho rõ ràng.
 */
function ApiAccessPage() {

	const [params, setParams] = useSearchParams();
	const tab = TABS.includes(params.get('tab')) ? params.get('tab') : 'keys';

	const {data: sub} = useGetMySubscriptionQuery();
	const canApi = !!sub?.features?.api;

	return (
		<div className="container">
			<PageHeader
				icon="fa-light fa-code"
				title="API & Webhook"
				subtitle="Tích hợp Omni SEO vào hệ thống của bạn — API public v1 + webhook sự kiện"
			/>

			{sub && !canApi && (
				<Alert
					type="warning"
					showIcon
					style={{marginBottom: 14}}
					message="Gói hiện tại không hỗ trợ API hệ thống"
					description="Bạn vẫn xem được tài liệu và thu hồi key/webhook cũ, nhưng cần nâng cấp gói để tạo API key hoặc webhook mới."
					action={
						<Button small primary to="/subscription"
							leftIcon={<FontAwesomeIcon icon="fa-light fa-crown" />}>
							Nâng cấp gói
						</Button>
					}
				/>
			)}

			<Tabs
				activeKey={tab}
				onChange={(key) => setParams(key === 'keys' ? {} : {tab: key})}
				items={[
					{
						key: 'keys',
						label: <span><FontAwesomeIcon icon="fa-light fa-key" /> API Keys</span>,
						children: <ApiKeysPanel canApi={canApi} />,
					},
					{
						key: 'webhooks',
						label: <span><FontAwesomeIcon icon="fa-light fa-tower-broadcast" /> Webhooks</span>,
						children: <WebhooksPanel canApi={canApi} />,
					},
					{
						key: 'docs',
						label: <span><FontAwesomeIcon icon="fa-light fa-book" /> Tài liệu API</span>,
						children: <ApiDocs />,
					},
				]}
			/>
		</div>
	);
}

export default ApiAccessPage;
